import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { SwiperContainer } from 'swiper/element';
import { SwiperOptions } from 'swiper/types';
import { register } from 'swiper/element/bundle';

register();

@Directive({
  selector: '[appSwiper]',
  standalone: true
})
export class SwiperDirective implements AfterViewInit {
  @Input('config') config?: SwiperOptions;

  constructor(private element: ElementRef<SwiperContainer>) {}

  ngAfterViewInit(): void {
    Object.assign(this.element.nativeElement, this.config)
    this.element.nativeElement.initialize();
  }
}
